import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { connect } from '../../Store';
import FooterImg from '../../assets/images/bg-footer-desktop.png';

const FooterMenu = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  ${({ theme }) => theme.media.s`
    display: inline-block;
  `};
  > li + li {
    margin-left: ${rem(20)};
  }
`;

// const FooterMenuItem = styled.li`
//   float: left;
//   color: ${({ theme }) => theme.color.textColor};
//   font-size: ${({ theme }) => theme.font.fontSizeXS};
//   text-transform: uppercase;
//   text-decoration: none;
//   transition: text-decoration 0.3s ease;
//   opacity: 1;
//   cursor: pointer;
//   &:hover {
//     text-decoration: underline;
//   }
// `;

const Copyright = styled.p`
  background-color: ${({ theme }) => theme.color.gray};
  padding-top: ${rem(8)};
  padding-bottom: ${rem(8)};
  margin-bottom: 0;
  text-align: center;
  color: ${({ theme }) => theme.color.copryrightTextColor};
  ${({ theme }) => theme.media.s`
    background-color: transparent;
    padding: 0;
    margin-bottom: ${rem(15)};
  `};
  opacity: 1;
`;

const Wrapper = styled.div`
  background-color: #ffffff;
  background-image: url(${props => props.bgImage});
  background-position: 50% 0%;
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  padding: ${rem(8)} 0;
`;

class Footer1 extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Wrapper bgImage={FooterImg}>
          <FooterMenu>
            {/* <FooterMenuItem>Obchodné podmienky</FooterMenuItem>
            <FooterMenuItem>Ochrana osobných údajov</FooterMenuItem>
            <FooterMenuItem>Kontakt</FooterMenuItem> */}
          </FooterMenu>
          <Copyright>
            Copyright © {new Date().getFullYear()}, Dejmark spol. s r.o.
          </Copyright>
        </Wrapper>
      </React.Fragment>
    );
  }
}

Footer1.propTypes = {};

Footer1.defaultProps = {};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Footer1);



// WEBPACK FOOTER //
// ./src/Containers/Footer/index.js